import {Injectable, Optional} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {BaseSite, BaseSiteLogo} from '@kion/data-models';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '../../../../../api-endpoint/src/lib/api.config';

interface IResponseItem {
  uid: string,
  channel: string,
  theme: string
  defaultLanguage: {
    active: true,
    isocode: string,
    name: string,
    nativeName: string
  },
  copyright?: string,
  logo?: BaseSiteLogo,
  multiVendor: boolean
  name?: string,
  openingHours?: string,
  partnerLogo?: BaseSiteLogo,
  phoneNumber?: string,
  guestCheckoutEnabled?: boolean
}

interface ISearchResponse {
  baseSites: IResponseItem[]
}

@Injectable({
  providedIn: 'root'
})
export class BaseSiteConnectors {

  private readonly _rootUrl: string;

  private route = 'basesites';

  constructor(
    @Optional() apiConfig: ApiConfig,
    private http: HttpClient,
  ) {
    this._rootUrl = apiConfig.rootUrl;
  }

  private static transformFromApi(response: IResponseItem): BaseSite {
    return {
      ...response,
      id: response.uid,
      isActive: false
    };
  }

  getAll(): Observable<BaseSite[]> {
    return this.http.get<ISearchResponse>(this.getManyUrl()).pipe(
      map((response: ISearchResponse) => response.baseSites.map(
        (responseItem: IResponseItem) => BaseSiteConnectors.transformFromApi(responseItem)
      )),
      catchError(error => {
        console.error('Load BaseSite error', error);
        return throwError('BaseSite could not be loaded!');
      })
    );
  }

  protected getManyUrl() {
    return this._rootUrl + this.route;
  }

  protected getOneUrl(id: number) {
    return this._rootUrl + this.route + id;
  }
}
